import inputsUtils from '@/utils/inputs';

export function handleKeydownInputNumber(event) {
    inputsUtils.preventEKeyInputNumber(event);

    if (event.key === '-' || event.key === 'ArrowDown') {
        event.preventDefault();
    }

    event.target.addEventListener('paste', e => {
        e.preventDefault();
    });
}
